/**
 * Format distance values to 1 decimal place
 * Handles undefined, null, and NaN values gracefully
 */
export const formatDistance = (value: number | undefined | null): string => {
    if (value === undefined || value === null || Number.isNaN(Number(value))) {
      return '';
    }
    return new Intl.NumberFormat(undefined, { maximumFractionDigits: 1 }).format(Number(value));
  };
  
  /**
   * Format elevation values (no decimals needed for meters)
   */
  export const formatElevation = (value: number | undefined | null): string => {
    if (value === undefined || value === null || Number.isNaN(Number(value))) {
      return '';
    }
    return new Intl.NumberFormat(undefined, { maximumFractionDigits: 0 }).format(Number(value));
  };